import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Joi from "joi-browser";
import geo from "../services/geoService";
import { getAlert } from "../services/appAlerts";
import { getCodeManager, loadCodeManager } from "../app/store/referenceData";

function AddPartnerPerformer(props) {
  const {
    handleFormSubmit,
    handlePermissionShowHide,
    loadCodeManager: loadPartnerUserTypes,
    partnerType,
    partnerUserTypes = [],
    selectedObj,
  } = props;
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [stateList, setStateList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [loginType, setLoginType] = useState(0);
  const [azureEmailId, setAzureEmailId] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadStates = async () => {
      const states = await geo.getStateList();
      if (isMounted) setStateList(states);
    };

    loadStates();
    loadPartnerUserTypes("Partner User Role");

    return () => {
      isMounted = false;
    };
  }, [loadPartnerUserTypes]);

  const schema = {
    name: Joi.string().required().label("Name"),
    email: Joi.string().email().required().label("Email"),
    contact: Joi.string()
      .length(10)
      .options({
        language: {
          string: {
            length: "Mobile No. must be 10 digits.",
          },
        },
      })
      .options({})
      .regex(/^[0-9]+$/)
      .options({
        language: {
          string: {
            regex: {
              base: "This entry can only contain numbers",
            },
          },
        },
      })
      .label("Mobile No."),
  };

  useEffect(() => {
    if (selectedObj && selectedObj !== "") {
      let azure = selectedObj.azureEmailId || "";
      if (azure.endsWith("@workfinity1.onmicrosoft.us")) {
        azure = azure.replace("@workfinity1.onmicrosoft.us", "");
      }

      setData(selectedObj);
      setLoginType(selectedObj.loginType || 0);
      setAzureEmailId(azure);
    } else {
      setData({});
      setLoginType(0);
      setAzureEmailId("");
    }
  }, [selectedObj]);

  useEffect(() => {
    if (selectedObj && selectedObj !== "") {
      const selectedState = stateList.find((item) => item.name === selectedObj.state);
      setSelectedStateId(selectedState ? selectedState.geonameId : "");
    } else {
      setSelectedStateId("");
    }
  }, [selectedObj, stateList]);

  const validate = () => {
    const options = { abortEarly: false, allowUnknown: true };
    const result = Joi.validate(data, schema, options);
    if (!result.error) return null;

    const validationErrors = {};
    result.error.details.forEach((item) => {
      if (item.type === "any.required") {
        validationErrors[item.path[0]] = item.message;
      }
    });

    return Object.keys(validationErrors).length > 0 ? validationErrors : null;
  };

  const validateProperty = ({ name, value }) => {
    if (!schema[name]) return null;
    const { error } = Joi.validate({ [name]: value }, { [name]: schema[name] });
    return error ? error.details[0].message : null;
  };

  const handleChange = ({ currentTarget: input }) => {
    const errorMessage = validateProperty(input);
    setErrors((currentErrors) => {
      const nextErrors = { ...currentErrors };
      if (errorMessage) nextErrors[input.name] = errorMessage;
      else delete nextErrors[input.name];
      return nextErrors;
    });
    setData((currentData) => ({ ...currentData, [input.name]: input.value }));
  };

  const updateState = (name, value) => {
    setData((currentData) => ({ ...currentData, [name]: value }));
    setErrors((currentErrors) => {
      const nextErrors = { ...currentErrors };
      delete nextErrors[name];
      return nextErrors;
    });
  };

  const handleStateChanged = ({ target: input }) => {
    const selectedOption = input.selectedOptions[0];
    setSelectedStateId(selectedOption.value);
    updateState(input.name, selectedOption.text);
  };

  const formatPhone = (value) => {
    if (!value) return "";
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const handlePhoneChange = (event) => {
    handleChange({
      currentTarget: {
        name: event.target.name,
        value: event.target.value.replace(/[^\d]/g, ""),
      },
    });
  };

  const doSubmit = async () => {
    const perf = { ...data };
    if (loginType === 1) {
      const azureEmailRegex = /^[a-zA-Z0-9.]+$/;
      if (!azureEmailId || !azureEmailRegex.test(azureEmailId)) {
        getAlert("", "Azure Email ID must contain only letters, numbers, or dots.", "error");
        return;
      }
      perf["azureEmailId"] = `${azureEmailId}@workfinity1.onmicrosoft.us`;
    } else {
      perf["azureEmailId"] = "";
    }
    perf["loginType"] = loginType;
    handleFormSubmit(perf);

    if (data["id"] > 0) {
      getAlert("", `${partnerType || "Partner"} User Updated Successfully`, "success");
    } else {
      getAlert("", `${partnerType || "Partner"} User Added Successfully`, "success");
    }
    if (handlePermissionShowHide) {
      handlePermissionShowHide();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors || {});
    if (!validationErrors) doSubmit();
  };

  const isEditMode = data && data.id > 0;
  const partnerLabel = partnerType || "Partner";

  return (
      <div className="appf-card">
        <style>{`
          @keyframes appfFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .appf-card {
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            background: #ffffff !important;
            box-shadow: none !important;
            margin-top: 10px;
            animation: appfFadeIn 0.3s ease both;
            overflow: hidden;
          }
          .appf-form-header {
            display: flex;
            align-items: center;
            gap: 14px;
            padding: 16px 22px;
            background: #ffffff !important;
            border-bottom: 1.5px solid #e2e8f0 !important;
          }
          .appf-form-header-icon {
            width: 42px;
            height: 42px;
            border-radius: 0 !important;
            background: #f5f5f5 !important;
            border: 1.5px solid #d4d4d4 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            color: #525252 !important;
            flex-shrink: 0;
          }
          .appf-form-header-text {
            min-width: 0;
            flex: 1;
          }
          .appf-form-header-title {
            color: #0f172a;
            font-size: 14.5px;
            font-weight: 600;
            margin: 0;
            line-height: 1.2;
          }
          .appf-form-header-sub {
            color: #64748b;
            font-size: 12px;
            margin-top: 3px;
            font-weight: 600;
          }
          .appf-form-header-badge {
            margin-left: auto;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            padding: 4px 12px;
            color: #475569;
            font-size: 11.5px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 6px;
            white-space: nowrap;
          }
          .appf-form-header-badge i { color: #64748b !important; }
          .appf-form-body { padding: 18px 22px; }
          .appf-section { margin-bottom: 22px; }
          .appf-section:last-child { margin-bottom: 0; }
          .appf-section-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 14px;
            padding-bottom: 9px;
            border-bottom: 1.5px solid #f1f5f9;
          }
          .appf-section-icon {
            width: 26px;
            height: 26px;
            border-radius: 0 !important;
            background: #f5f5f5 !important;
            border: 1px solid #d4d4d4 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #525252 !important;
          }
          .appf-section-title {
            font-size: 11px;
            font-weight: 600;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.7px;
          }
          .appf-card .form-control-label {
            font-size: 11px !important;
            font-weight: 600 !important;
            color: #64748b !important;
            text-transform: uppercase !important;
            letter-spacing: 0.7px !important;
            margin-bottom: 6px !important;
            display: flex !important;
            align-items: center !important;
            gap: 5px !important;
          }
          .appf-card .form-control-label i { color: #94a3b8; font-size: 11px; }
          .appf-card .form-group { margin-bottom: 16px; }
          .appf-card .required .form-control-label::after {
            content: " *" !important;
            position: static !important;
            font-family: inherit !important;
            color: #ef4444 !important;
            font-weight: 600 !important;
            font-size: 13px !important;
            line-height: 1 !important;
            margin-left: 3px !important;
          }
          .appf-input-wrap { position: relative; }
          .appf-input-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #94a3b8;
            font-size: 13px;
            pointer-events: none;
            transition: color 0.2s ease;
            z-index: 1;
          }
          .appf-input-wrap:focus-within .appf-input-icon { color: #2563eb; }
          .appf-card .form-control,
          .appf-card .appf-select {
            border-radius: 0 !important;
            border: 1.5px solid #e2e8f0 !important;
            height: 38px !important;
            min-height: 38px !important;
            max-height: 38px !important;
            box-sizing: border-box !important;
            line-height: normal !important;
            padding: 0 14px !important;
            font-size: 13.5px !important;
            color: #1e293b !important;
            background-color: #ffffff !important;
            transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
            width: 100% !important;
          }
          .appf-card .form-control::placeholder { color: #94a3b8 !important; }
          .appf-card .form-control:hover,
          .appf-card .appf-select:hover {
            border-color: #94a3b8 !important;
            box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
          }
          .appf-card .form-control:focus,
          .appf-card .appf-select:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
            outline: none !important;
            background-color: #fafbff !important;
          }
          .appf-card .appf-select {
            appearance: none !important;
            -webkit-appearance: none !important;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat !important;
            background-position: right 12px center !important;
            padding-right: 32px !important;
            cursor: pointer !important;
          }
          .appf-card .alert.alert-danger {
            padding: 5px 10px !important;
            font-size: 11.5px !important;
            border-radius: 0 !important;
            margin-top: 5px !important;
            margin-bottom: 0 !important;
          }
          .appf-auth-card {
            flex: 1; border: 2px solid #e2e8f0; border-radius: 0 !important;
            padding: 12px 14px; display: flex; align-items: center; gap: 11px;
            cursor: pointer; transition: all 0.2s ease; position: relative;
            background: #ffffff; user-select: none;
          }
          .appf-auth-card:hover {
            border-color: #cbd5e1; background: #f8fafc;
            transform: translateY(-1px); box-shadow: 0 4px 12px rgba(15,23,42,0.03);
          }
          .appf-auth-card.active {
            border-color: #171717; background: #ffffff;
            box-shadow: none;
          }
          .appf-auth-card-icon {
            font-size: 18px; min-width: 36px; height: 36px; border-radius: 0 !important;
            display: flex; align-items: center; justify-content: center;
            background: #f1f5f9; transition: all 0.2s ease; color: #64748b;
          }
          .appf-auth-card.active .appf-auth-card-icon {
            background: #171717; color: #ffffff !important;
          }
          .appf-auth-card-content { display: flex; flex-direction: column; text-align: left; }
          .appf-auth-card-title { font-size: 13px; font-weight: 600; color: #1e293b; }
          .appf-auth-card-desc { font-size: 11px; color: #64748b; margin-top: 2px; line-height: 1.3; }
          .appf-auth-card-badge {
            position: absolute; top: 10px; right: 10px;
            color: #171717; font-size: 15px; line-height: 1;
          }
          .appf-azure-field {
            border: 1.5px solid #e2e8f0; border-radius: 0 !important;
            background: #ffffff; padding: 13px 15px;
            animation: appfFadeIn 0.25s ease both;
          }
          .appf-card .input-group .form-control {
            border-radius: 0 !important;
            padding-left: 14px !important;
          }
          .appf-card .input-group-text {
            border: 1.5px solid #e2e8f0 !important; border-left: none !important;
            border-radius: 0 !important; background: #ffffff !important;
            color: #475569 !important; font-size: 12.5px !important;
            padding: 0 14px !important; display: flex; align-items: center;
          }
          .appf-field-hint {
            font-size: 11px;
            color: #94a3b8;
            margin-top: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
          }
          .appf-form-footer {
            display: flex;
            align-items: center;
            justify-content: center !important;
            gap: 10px;
            flex-wrap: wrap;
            padding: 14px 22px;
            border-top: 1.5px solid #f1f5f9;
            background: #ffffff !important;
          }
        `}</style>

        <div className="appf-form-header">
          <div className="appf-form-header-icon">
            <i className={`fa ${isEditMode ? "fa-pencil-square-o" : "fa-user-plus"}`} />
          </div>
          <div className="appf-form-header-text">
            <p className="appf-form-header-title">
              {isEditMode ? "Edit Partner User" : `Add New ${partnerLabel} User`}
            </p>
            <p className="appf-form-header-sub">
              {isEditMode
                ? `Updating record for ${data.name || "selected user"}`
                : `Fill in the details below to add a user for this ${partnerLabel.toLowerCase()}.`}
            </p>
          </div>
          {isEditMode && data.id && (
            <div className="appf-form-header-badge">
              <i className="fa fa-id-badge" /> User #{data.id}
            </div>
          )}
        </div>

        <div className="appf-form-body">
          <div className="appf-section">
            <div className="appf-section-header">
              <div className="appf-section-icon"><i className="fa fa-id-card-o" /></div>
              <span className="appf-section-title">Role &amp; Identity</span>
            </div>

            <div className="row">
              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfTitleSelect">
                  User Type
                </label>
                <div className="appf-input-wrap">
                  <select
                    id="appfTitleSelect"
                    name="title"
                    className="form-control appf-select"
                    value={data.title || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select user type</option>
                    {partnerUserTypes.map((role) => (
                      <option key={role.id || role.name} value={role.name}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>
                {errors.title && <div className="alert alert-danger">{errors.title}</div>}
                <p className="appf-field-hint">
                  <i className="fa fa-info-circle" />
                  Select the partner user role for this account.
                </p>
              </div>

              <div className="col-lg-6 form-group required">
                <label className="form-control-label" htmlFor="appfName">
                  Full Name
                </label>
                <div className="appf-input-wrap">
                  <input
                    type="text"
                    name="name"
                    id="appfName"
                    value={data.name || ""}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Full Name"
                  />
                </div>
                {errors.name && <div className="alert alert-danger">{errors.name}</div>}
              </div>

              <div className="col-lg-6 form-group required">
                <label className="form-control-label" htmlFor="appfEmail">
                  Email Address
                </label>
                <div className="appf-input-wrap">
                  <input
                    type="email"
                    name="email"
                    id="appfEmail"
                    value={data.email || ""}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Email Address"
                  />
                </div>
                {errors.email && <div className="alert alert-danger">{errors.email}</div>}
              </div>

              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfContact">
                  Mobile No.
                </label>
                <div className="appf-input-wrap">
                  <input
                    type="text"
                    name="contact"
                    id="appfContact"
                    value={formatPhone(data.contact || "")}
                    onChange={handlePhoneChange}
                    className="form-control"
                    placeholder="Mobile No."
                  />
                </div>
                {errors.contact && <div className="alert alert-danger">{errors.contact}</div>}
              </div>
            </div>
          </div>

          <div className="appf-section">
            <div className="appf-section-header">
              <div className="appf-section-icon"><i className="fa fa-map-marker" /></div>
              <span className="appf-section-title">Location</span>
            </div>

            <div className="row">
              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfStateList">
                  State
                </label>
                <div className="appf-input-wrap">
                  <select
                    className="form-control appf-select"
                    id="appfStateList"
                    name="state"
                    value={selectedStateId}
                    onChange={handleStateChanged}
                  >
                    <option value="0">Select State</option>
                    {stateList.map((s) => (
                      <option key={s.geonameId} value={s.geonameId}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfCounty">
                  City
                </label>
                <div className="appf-input-wrap">
                  <input
                    type="text"
                    name="county"
                    id="appfCounty"
                    value={data.county || ""}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="City"
                  />
                </div>
                {errors.county && <div className="alert alert-danger">{errors.county}</div>}
              </div>
            </div>
          </div>

          {/* Section 3: Authentication Mode */}
          <div className="appf-section">
            <div className="appf-section-header">
              <div className="appf-section-icon"><i className="fa fa-lock" /></div>
              <span className="appf-section-title">Login Authentication</span>
            </div>
            <div className="row">
              <div className="col-lg-12 form-group">
                <div className="d-flex align-items-stretch" style={{ gap: "14px", flexWrap: "wrap" }}>
                  <div
                    className={`appf-auth-card${loginType === 0 ? " active" : ""}`}
                    onClick={() => setLoginType(0)}
                    role="button" tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && setLoginType(0)}
                  >
                    <div className="appf-auth-card-icon"><i className="fa fa-desktop" /></div>
                    <div className="appf-auth-card-content">
                      <span className="appf-auth-card-title">System Login</span>
                      <span className="appf-auth-card-desc">Standard local credentials access</span>
                    </div>
                    {loginType === 0 && (
                      <div className="appf-auth-card-badge"><i className="fa fa-check-circle" /></div>
                    )}
                  </div>

                  <div
                    className={`appf-auth-card${loginType === 1 ? " active" : ""}`}
                    onClick={() => setLoginType(1)}
                    role="button" tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && setLoginType(1)}
                  >
                    <div className="appf-auth-card-icon"><i className="fa fa-windows" /></div>
                    <div className="appf-auth-card-content">
                      <span className="appf-auth-card-title">Azure AD Login</span>
                      <span className="appf-auth-card-desc">Microsoft cloud single sign-on</span>
                    </div>
                    {loginType === 1 && (
                      <div className="appf-auth-card-badge"><i className="fa fa-check-circle" /></div>
                    )}
                  </div>
                </div>
              </div>

              {loginType === 1 && (
                <div className="col-lg-12 form-group">
                  <div className="appf-azure-field">
                    <label className="form-control-label" htmlFor="appfAzureEmailId">
                      Azure AD Email ID
                    </label>
                    <div className="input-group">
                      <div className="appf-input-wrap" style={{ flex: 1 }}>
                        <input
                          type="text"
                          id="appfAzureEmailId"
                          className="form-control"
                          value={azureEmailId}
                          onChange={(e) => setAzureEmailId(e.target.value)}
                          placeholder="e.g. john.doe"
                          autoComplete="off"
                          autoCapitalize="none"
                        />
                      </div>
                      <div className="input-group-append">
                        <span className="input-group-text" style={{ fontWeight: 600 }}>
                          @workfinity1.onmicrosoft.us
                        </span>
                      </div>
                    </div>
                    <p className="appf-field-hint">
                      <i className="fa fa-info-circle" />
                      Enter only the username part — the domain is appended automatically.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>

        <div className="appf-form-footer">
          <button
            type="button"
            className="btn-action-search"
            onClick={handlePermissionShowHide}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back to Users
          </button>
          <button
            className="btn-action-search btn-primary-search"
            disabled={validate()}
            onClick={handleSubmit}
          >
            <i className="fa fa-check" aria-hidden="true" />
            {isEditMode ? "Save Changes" : "Add User"}
          </button>
        </div>
      </div>
  );
}

const mapStateToProps = (state) => ({
  partnerUserTypes: getCodeManager("Partner User Role")(state),
});

const mapDispatchToProps = {
  loadCodeManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPartnerPerformer);
